import React, { useState, useEffect } from "react";
import { Button, Modal } from "react-bootstrap";
import Input from "rsuite/Input";
import { unifiedEnvConfig } from "../../constants/api-endpoint";
import { httpPost } from "../../utility/requestHelper";
import { EmailIcon } from "../Icons/icons.component";
import { groupBy, isLoggedIn } from "../../utility/common-methods";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import TagPicker from 'rsuite/TagPicker';
const [INPROGRESS, SUCESS, FAILED] = [
  "Ticket Creation In Progress...",
  "Ticket Created succesfully",
  "Failed to create ticket",
];

const { TICKET_CREATE } = unifiedEnvConfig;
export default function TicketPopup({
  detail
}) {
  const [status, setStatus] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [statusMessage, setstatusMessage] = useState("");
  const [userId, setuserId] = useState([]);
  const [masterUserId, setmasterUserId] = useState([]);
  const [msg, setmsg] = useState("");
  const [progressStatus, setprogressStatus] = useState(false);
  const subUsers =
    useSelector(
      (state) => state.clientReducer && state.clientReducer.subUser
    ) || [];
  const masterUser =
    useSelector(
      (state) => state.clientReducer && state.clientReducer.masterUser
    ) || {};
  const masterUsers =
    useSelector(
      (state) => state.clientReducer && state.clientReducer.masterUsers
    ) || {};
  const selectedClient =
    useSelector(
      (state) => state.clientReducer && state.clientReducer.selectedClient
    ) || {};
  const history = useHistory();
  const create = async () => {
    const client_id = selectedClient && selectedClient.id;
    if (!client_id) {
      alert("Ticket function is not allowed");
      return;
    }

    if (!masterUserId.length) {
      setStatus("Please select Master User ");
      return;
    }

    if (!userId.length) {
      setStatus("Please select sub user ");
      return;
    }
    if (msg == "") {
      setStatus("Please provide message for ticket ");
      return;
    }
    setStatus(INPROGRESS);
    setprogressStatus(true);
    let resData = await httpPost(TICKET_CREATE, {
      ...detail,...{
        client_id : client_id,
        master_id : masterUser.id,
        selected_sub_user_id : userId,
        message : msg,
        user_id : masterUser.user_id,
        master_ids : masterUserId
      }
    })
    if(resData.data){
      setStatus(SUCESS);
      setprogressStatus(false);
      setTimeout(() => {
        setShowPopup(false)
      }, 1000);
    }
  };
  
  const closeModal = () => {
    setStatus("");
    setmsg("");
  };

  const handleTicketPopupClick = () => {
    if (isLoggedIn()) {
      setShowPopup(true);
      // setShareClickMessage("");
    } else {
      history.push("/");
    }
  };

  return (
    <>
      <Modal
        onHide={() => setShowPopup(false)}
        show={showPopup}
        onExit={closeModal}
        className="customModalWrap sharePopup"
      >
        <Modal.Header closeButton>
          <Modal.Title>Ticket Creation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="form-group">
            <label>Ticket Masters</label>
            <TagPicker data={masterUsers.length?masterUsers.filter((mData) => !userId.includes(Number(mData.user_id))).map((data) => ({label: data.name, value: data.id})):[]} style={{ width: 300 }} onChange={(e) => {setmasterUserId(e)}} />
          </div>
          <div className="form-group">
            <label>Ticket Assigned to </label>
            <TagPicker data={subUsers.length?subUsers.filter((sData) => !(masterUsers.length?masterUsers.filter(mData => masterUserId.includes(mData.id)).map(mData=> Number(mData.user_id)).includes(sData.userId):false)).map((data) => ({label: data.name, value: data.userId})):[]} style={{ width: 300 }} onChange={(e) => {setuserId(e)}} />
          </div>
          <div className="form-group">
            <label>Message</label>
            <textarea
              id="message" 
              className="form-control" 
              required
              value={msg}
              onChange={(v) => {setmsg(v.target.value)}}
              placeholder="Enter Message Here"
            />
            {/* <Input
              // htmlSize={10} 
              style={{ width: '300' }}
              id="message"
              required
              value={msg}
              placeholder="Enter Message Here"
              className="form-control"
              onChange={(v) => setmsg(v)}
            /> */}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="btnWithMessage">
            <p
              className={`mr-auto text-${
                status === INPROGRESS || status === SUCESS
                  ? "success"
                  : "danger"
              }`}
            >
              {status}
            </p>
            <Button
              variant="default"
              onClick={() => create()}
              disabled={progressStatus}
              className="btn btnBlue"
            >
              Create Ticket
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
      <div className="shareBtnWrap mr-3 ml-2">
        <Button onClick={() => handleTicketPopupClick()} className="shareBtn">
          <div className="hasTooltip">
            <EmailIcon fill={"#0036b9"} />
            <span className="tooltipWrap center">Create Ticket</span>
          </div>
        </Button>
        {statusMessage && (
          <div className="sharedMessage">{statusMessage}</div>
        )}
      </div>
    </>
  );
}